import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './SimpleFooter.module.scss';
const SimpleFooter = () => {
    return (_jsx("footer", { className: styles.footer, role: "contentinfo", children: _jsx("div", { className: styles.footer__copyright, children: _jsxs("p", { children: [_jsx("span", { children: "\u00A92025 Endurance Technologies. All Rights Reserved." }), _jsx("span", { className: styles.footer__divider, children: "|" }), "Hosting by ", _jsx("a", { href: 'https://www.heroku.com/', children: "Heroku" })] }) }) }));
};
export default SimpleFooter;
